import React, { useEffect, useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { tokens } from '../theme';
import { formatKey } from '../Utils/Functions';
import { useGetRolesQuery } from '../services/SkillsManagement';

const RoleChip = ({ role, colorOverride = null, bgColorOverride = null }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { data: { roles: rolesData } = {} } = useGetRolesQuery({
        filters: "",
        pagination: "",
        sorting: "",
    });
    const [color, setColor] = useState(null);
    const [bgColor, setBgColor] = useState(null);

    const colorPalette = [
        { main: colors.skyBlue[500], bg: colors.skyBlue[100] },
        // // { main: colors.teal[500], bg: colors.teal[100] },
        // { main: colors.indigo[500], bg: colors.indigo[100] },
        { main: colors.Yellow[600], bg: colors.Yellow[100] },
        { main: colors.Pink[400], bg: colors.Pink[100] },
        { main: colors.purple[500], bg: colors.purple[100] },
         { main: colors.redAccent[600], bg: colors.redAccent[100] },
        { main: colors.green[700], bg: colors.green[100] },
        { main: colors.Orange[400], bg: colors.Orange[100] },
        // { main: colors.Blue[600], bg: colors.Blue[100] },
        // // { main: colors.secondary[500], bg: colors.secondary[20] },
        // { main: colors.primary[400], bg: colors.primary[100] }
    ];

    // Defensive extraction of role label for formatKey and color
    const getRoleLabel = (role) => {
        if (!role) return '';
        if (typeof role === 'string') return role;
        if (typeof role === 'object' && role.name) return role.name;
        return String(role);
    };

    const getRoleColors = (roleKey) => {
        // Add a check for undefined/null roleKey
        if (!roleKey) {
            // Return a default color when role is undefined/null
            return colorPalette[0];
        }

        // If rolesData is not loaded yet, generate a color based on the role name
        if (!Array.isArray(rolesData)) {
            const hashCode = roleKey.split('').reduce((acc, char) => {
                return char.charCodeAt(0) + ((acc << 5) - acc);
            }, 0);
            return colorPalette[Math.abs(hashCode) % colorPalette.length];
        }
        
        const roleIndex = rolesData.findIndex(r => r.name === roleKey);
        // If role is not found in data, still give it a consistent color based on name
        if (roleIndex === -1) {
            const hashCode = roleKey.split('').reduce((acc, char) => {
                return char.charCodeAt(0) + ((acc << 5) - acc);
            }, 0);
            return colorPalette[Math.abs(hashCode) % colorPalette.length];
        }
        return colorPalette[roleIndex % colorPalette.length];
    };

    useEffect(() => {
        if (colorOverride || bgColorOverride) {
            // Use provided overrides if present
            setColor(colorOverride || colors.primary[500]);
            setBgColor(bgColorOverride || colors.primary[100]);
            return;
        }
        // Fallback to computed colors
        const colorData = getRoleColors(getRoleLabel(role)) || colorPalette[0];
        const { main, bg } = colorData;
        setColor(main);
        setBgColor(bg);
    }, [role, rolesData, colorOverride, bgColorOverride, colors]);

    return (
        <Box sx={{
            padding: "4px 12px",
            color: color,
            // borderBottom: `2px solid ${color}`,
            borderRadius: "10px",
            fontSize: "0.85rem",
            fontWeight: "500",
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 'fit-content',
            backgroundColor: bgColor,
            minWidth: '80px',
            maxWidth: '120px',
            boxShadow: '0 0 2px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.2s ease-in-out',

        }}>
            <span style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                whiteSpace: 'nowrap'
            }}>
                <span style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor: color,
                    display: 'inline-block'
                }} />
                {formatKey(getRoleLabel(role))}
            </span>
        </Box>
    )
}

export default RoleChip;